import Component from 'inferno-component';
import { Grid, Icon } from 'semantic-ui-react';

export default class ContactItem extends Component {
  render() {
    return (
      <Grid.Column textAlign='center'>
        <div style={{textAlign: 'center', marginTop: '25px', marginBottom: '5px'}}>
          <Icon className='icon' color={this.props.color} name={this.props.name} size='big'/>
        </div>
        <div>
            {this.props.children}
        </div>
      </Grid.Column>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contact/ContactItem.js